// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-AutoExclusions-components-Flash-module__alert";
var _2 = "webpack-pages-AutoExclusions-components-Flash-module__alertWarning";
var _3 = "webpack-pages-AutoExclusions-components-Flash-module__container";
var _4 = "webpack-pages-AutoExclusions-components-Flash-module__flashContainer";
var _5 = "webpack-pages-AutoExclusions-components-Flash-module__notice";
var _6 = "webpack-pages-AutoExclusions-components-Flash-module__text";
export { _1 as "alert", _2 as "alertWarning", _3 as "container", _4 as "flashContainer", _5 as "notice", _6 as "text" }
